export const SELECT_AMAZON_SELLER_ACCOUNT = 'SELECT_AMAZON_SELLER_ACCOUNT'
export const RESET_GLOBAL_DATA = 'RESET_GLOBAL_DATA'
export const DECREMENT_FEATURE_USAGE_COUNT = 'DECREMENT_FEATURE_USAGE_COUNT'
